import { klaviyoApi } from 'shared/api/requests/integrations/klaviyo'
import { createAsyncAction } from 'shared/lib/redux'

export const getLists = createAsyncAction('integration/klaviyo/getLists', async () => {
  const response = await klaviyoApi.getLists()
  return response.data
})

export const getFields = createAsyncAction('integration/klaviyo/getFields', async () => {
  const response = await klaviyoApi.getFields()
  return response.data
})
